import { useMemo, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Pricing from "./components/Pricing";
import Team from "./components/Team";
import Contact from "./components/Contact";
import EditModeBar from "./components/EditModeBar";
import ErrorPage from "./components/ErrorPage";
import TermsModal from "./components/TermsModal";

function App() {
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const isErrorRoute = useMemo(() => {
    const path = window.location.pathname.replace(/\/$/, "") || "/";
    return path === "/error" || path === "/404";
  }, []);

  if (isErrorRoute) {
    return <ErrorPage />;
  }

  return (
    <div className="App w-full max-w-[100vw] overflow-x-hidden relative">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Pricing />
      <Team />
      <Contact onOpenTerms={() => setTermsModalOpen(true)} />
      <TermsModal isOpen={termsModalOpen} onClose={() => setTermsModalOpen(false)} />
      <EditModeBar />
    </div>
  );
}

export default App;

